import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { createContext } from "react";
import { useParams } from "react-router-dom";
import { GET_ORDER_INFO } from "./graphql";
import OrderForm from "./OrderForm";

export const OrderContext = createContext();

const OrderDetail = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(GET_ORDER_INFO, {
    variables: { id },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const activeCurrencies = JSON.parse(data.odooActiveCurrencies);
  const odooPricelists = JSON.parse(data.odooPricelists).reduce(
    (acc, { id, currency_id, display_name }) => {
      const code = currency_id?.display_name;
      if (code && !acc.some((item) => item.currency === code)) {
        acc.push({ id, name: display_name, currency: code });
      }
      return acc;
    },
    [],
  );
  const stockCategoryLatestStocks = JSON.parse(
    data.stockCategoryLatestStocks || "[]",
  );

  const productStocks = Object.values(stockCategoryLatestStocks).reduce(
    (stocks, { product_id, latest_qty }) => ({
      ...stocks,
      [product_id]: latest_qty,
    }),
    {},
  );

  return (
    <OrderForm
      originalOrder={data.order}
      stockCategories={data.stockCategories}
      activeCurrencies={activeCurrencies}
      odooPricelists={odooPricelists}
      productStocks={productStocks}
    />
  );
};

export default OrderDetail;
